import Vue from 'vue';
import VueAmplitude from 'vue-amplitude';

Vue.use(VueAmplitude, {"apiKey":"40dd8785805b57c00e742cda5adc4474"});
